// `/account` WITH THE SERVER'S WEB_ACCOUNTS_ENABLED ON, and F3 (ACC-3a).
//
// WHO SEES WHAT AT `/account`. A look-around (or nobody) sees "Create your account" — it is on the way to paying, and
// paying needs an account. Someone ALREADY signed in to an account sees the assent page, exactly as today: they agree to
// the current terms before paying, as every owner does, and nothing about their account needs making. Decided once, on
// arrival, so the account this page is creating cannot swap the page out from under its own last steps.
//
// WEB-DESIGN-1 (Tyler's walk decision 2, 2026-10-05): the signed-in owner who already agreed — at sign-up (A7/A8), or
// on this page before — skips the terms page. The SERVER says so (`legal.consentOnFile`, 2.24.0); the assent page reads
// it and goes on to `/checkout`. No consent on file, or an older version: the assent page, as before.
//
// F3 — "You're signed out. Sign in to pick up where you left off." — stands in for a paid page when the sign-in ended
// under this page (the account deleted in the app, or its sign-in revoked; `app/accounts.tsx` `useSignInEnded`), with
// "Sign in" (B4), which brings the owner back to the page they were on.

import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { signedIn } from "../../app/accounts";
import { useSession } from "../../app/session";
import { heldText } from "../../components/heldCopy";
import { Assent } from "../assent";
import { CreateAccount } from "./CreateAccount";
import { HeroTile, Say } from "./parts";

export function AccountDoor() {
  const session = useSession();
  const [lookAround] = useState(() => !signedIn(session.auth));
  // WEB-DESIGN-1 (decision 2): a signed-in owner whose consent the server holds goes on to `/checkout`.
  return lookAround ? <CreateAccount /> : <Assent skipWhenOnFile />;
}

export function SignedOut() {
  const location = useLocation();
  return (
    <section className="account-page" data-account-screen="signed-out">
      <HeroTile />
      <Say id="account.signedOut.paid" className="account-lead" />
      <p className="account-links">
        <Link className="btn primary block" to="/signin" state={{ from: location.pathname }} data-held-copy="account.signIn.button">
          {heldText("account.signIn.button")}
        </Link>
      </p>
    </section>
  );
}
